// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"657":"12c8ac22","924":"9c9a354f"}[chunkId] + ".chunk.css";
};